export default __webpack_public_path__ + "static/media/radio-btn-selected.353ccfeb.svg";